import React from 'react';
import {Box, Typography} from '@mui/material';

const NAVY   = '#052F44';
const ORANGE = '#FF6900';
const TEAL   = '#1B6B55';

const COHORT_ROWS = [
    {label: 'Primary (8–11)',          pct: 68},
    {label: 'Lower-secondary (12–14)', pct: 63},
    {label: 'Upper-secondary (15–18)', pct: 54},
    {label: 'Parent-supported',        pct: 71},
    {label: 'No adult follow-up',      pct: 46},
];

const IntentionForChangeTab = () => (
    <Box>
        <Box sx={{display: 'flex', gap: 2.5, alignItems: 'stretch'}}>

            {/* ── Left: stat card ── */}
            <Box sx={{
                flex: '0 0 36%',
                border: '1px solid var(--brand-border, #E5E7EB)',
                borderRadius: '12px',
                backgroundColor: 'var(--brand-surface, #ffffff)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                gap: 1.5,
            }}>
                <Typography sx={{fontSize: '18px', fontWeight: 800, color: NAVY}}>
                    Intention to change
                </Typography>

                {/* Big stat */}
                <Typography sx={{
                    fontSize: '80px',
                    fontWeight: 800,
                    color: NAVY,
                    lineHeight: 1,
                    mt: 1,
                }}>
                    61%
                </Typography>

                <Typography sx={{fontSize: '14px', color: '#374151', lineHeight: 1.6, mt: 0.5}}>
                    of participants reported an intention to change a specific online behaviour after
                    completing the program.
                </Typography>

                {/* Readiness signal chip */}
                <Box sx={{
                    display: 'inline-block',
                    alignSelf: 'flex-start',
                    backgroundColor: 'var(--brand-surface-subtle, #FEF9C3)',
                    color: '#A16207',
                    fontSize: '13px',
                    fontWeight: 600,
                    px: 2.2,
                    py: 0.7,
                    borderRadius: '8px',
                    mt: 1,
                }}>
                    Readiness signal
                </Box>
            </Box>

            {/* ── Right: intention by cohort ── */}
            <Box sx={{
                flex: 1,
                border: '1px solid var(--brand-border, #E5E7EB)',
                borderRadius: '12px',
                backgroundColor: 'var(--brand-surface, #ffffff)',
                boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
                p: 3,
            }}>
                <Typography sx={{fontSize: '18px', fontWeight: 800, color: NAVY, mb: 3}}>
                    Intention by cohort
                </Typography>

                <Box sx={{display: 'flex', flexDirection: 'column', gap: 2.2}}>
                    {COHORT_ROWS.map((row) => (
                        <Box key={row.label} sx={{display: 'flex', alignItems: 'center', gap: 2}}>
                            <Typography sx={{fontSize: '14px', color: '#374151', minWidth: '195px', flexShrink: 0}}>
                                {row.label}
                            </Typography>
                            <Box sx={{flex: 1, height: '22px', borderRadius: '4px', backgroundColor: 'var(--brand-surface-subtle, #E5E7EB)', overflow: 'hidden'}}>
                                <Box sx={{
                                    width: `${row.pct}%`,
                                    height: '100%',
                                    backgroundColor: NAVY,
                                    borderRadius: '4px',
                                    transition: 'width 0.4s ease',
                                }}/>
                            </Box>
                            <Typography sx={{fontSize: '15px', fontWeight: 700, color: NAVY, minWidth: '42px', textAlign: 'right', flexShrink: 0}}>
                                {row.pct}%
                            </Typography>
                        </Box>
                    ))}
                </Box>

                <Typography sx={{fontSize: '12px', color: '#9CA3AF', fontStyle: 'italic', mt: 3, lineHeight: 1.6}}>
                    Treat as a readiness signal, not proof of behaviour change.
                </Typography>
            </Box>

        </Box>

        {/* Decision guidance footer */}
        <Box sx={{
            mt: 3,
            p: {xs: 2, md: 2.5},
            backgroundColor: 'var(--brand-surface-subtle, #EFF6FF)',
            border: '1px solid #BFDBFE',
            borderLeft: `4px solid ${NAVY}`,
            borderRadius: '0 8px 8px 0',
        }}>
            <Typography sx={{fontSize: '13px', color: '#374151', lineHeight: 1.7}}>
                <strong style={{color: NAVY}}>Decision guidance:&nbsp;</strong>
                Intention is lowest where there is no adult follow-up (46%). Improve parent and teacher
                support messaging in those cohorts — intention is a readiness measure, not impact evidence.
            </Typography>
        </Box>
    </Box>
);

export default IntentionForChangeTab;
